export const TRANSLATIONS_RU = {
  certificateLabel: 'Выберите Сертификат',
  detachedSignature: 'Сформировать открепленную подпись',
  successSigningDocument: 'Документ успешно подписан',
  failureSigningDocument: 'Ошибка подписания документа',
  noData: 'Нет документов для подписания',
  snackBarSuccessLoadingMessage: 'Данные успешно загружены',
  snackBarFilesLoadingMessage: 'Файлы успешно загружены и обрабатываются',
  snackBarNoFilesMessage: 'Файлы не найдены в документе',
  snackBarResetWarning: 'Страница будет перезагружена',
  snackBarResetError: 'Ошибка операции',
  snackBarSignSuccessMessage: 'Файлы успешно подписаны',
  snackBarSigErrorMessage: 'Ошибка подписания Файлов',
  snackBarFailureLoadingMessage: 'Ошибка загрузки данных',
  snackBarWarningLoadingMessage: 'Нет файлов для подписания',
  noCertificateMessage: 'Сертификат не выбран',
  successMessage: 'Все файлы успешно подписаны',
  errorMessage: 'Ошибка подписания всех файлов',
  allFilesTooltip:
    'Статус подписания файлов. Если хоты бы один файл не будет подписан, общий результат будет ошибкой.',

  counterTooltip:
    'Статус подписания документов. Если хоты бы один документ не будет подписан, общий результат будет ошибкой.',

  cetrificateTooltip:
    'Выбор сертификата. Если сертификат не выбран, подписать документ будет невозможно.',

  signatureTooltip: 'Сформировать только подпись.',
  signOutTooltip: 'Выйти из приложения.',
  signInDocumentTooltip:
    'Подписать выбранные документы. Активна если выделены документы и выбран сертификат.',

  globalSearch: 'Общий поиск',
  noCourt: 'Суд не указан',
  found: 'соответствий найдено',
  search: 'Поиск',
  reset: 'Сбросиь',
  filter: 'Фильтр',
  close: 'Закрыть',

  mainColumns: {
    senderUserName: 'Иицииатор',
    senderUserEmail: 'Электронная почта',
    mainIntegrationId: 'Номер долга в билинге',
    subIntegrationId: 'Номер процесса',
    receiverCourtCode: 'Судебный участок',
    courtExpensesSum: 'Гос. пошлина',
    legalParticipants: 'Поставщик',
    companyName: 'Имя компании',
    personalParticipants: 'Ответчик',
    realtyAddress: 'Адрес объекта',
    postalCode: 'Индекс',
    debtPeriod: 'Период',
    periodStartDate: 'Начало периода',
    periodEndDate: 'Конец периода',
    mainDebt: 'Основной долг',
    myDocuments: 'Мои документы',
    allDocuments: 'Все документы',
  },
  details: {
    participantsInformation: 'Информация об участниках',
    debtInformation: 'Информация о долге',
    filesInformation: 'Информация о файлах',
    caseCategoryName: 'Описание',
    courtExpensesSum: 'Затраты суда',
    legalParticipants: 'Представители',
    outgoingDocNum: 'Номер документа',
    personalParticipants: 'Физические лица',
    suitEssence: 'Описание',
    sum: 'Сумма',
    userFullName: 'ФИО',
    debtPeriodEndDate: 'Дата окончания',
    debtPeriodStartDate: 'Дата начала',
    mainDebt: 'Основной долг',
    penalty: 'Пени',
    fileName: 'Файлы',
    postalCode: 'Индекс',
    realtyAddress: 'Адрес',
    senderUserEmail: 'Адрес электронной почты',
    subIntegrationId: 'Номер документа',
    noData: 'Нет данных',
  },
  responseMessages: {
    errorLoading: 'Ошибка загрузки данных.',
    applyValidation: 'Использовать валидацию.',
  },
  buttons: {
    save: 'Сохранить',
    cancel: 'Отмена',
    close: 'Закрыть',
    signDocuments: 'Подписать документы',
    logOut: 'выйти',
    resetFreesed: 'Обновить зависшие',
  },
  titles: {
    editPersonalData: 'Детальная информация о документе',
    finishedDocuments: 'Обработано документов: ',
  },
};
